import VueRouter from "vue-router";

let originPush = VueRouter.prototype.push
let originReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        originPush.call(this, location, resolve, reject)
    } else {
        originPush.call(this, location, () => {
        }, () => {
        })
    }
}
VueRouter.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject)
    } else {
        originReplace.call(this, location, () => {
        }, () => {
        })
    }
}

const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: () => import("@/views/group/index.vue"),
            redirect: '/home',
            children: [
                {
                    path: '/home',
                    component: () => import("@/views/group/Home/home.vue")
                },
                // {
                //     path: '/investor-relations',
                //     component: () => import("@/views/group/InvestorRelations/investor-relations.vue")
                // },
                // {
                //     path: '/investor-relations/:key',
                //     component: () => import("@/views/group/InvestorRelations/more.vue")
                // },
                {
                    path: '/about',
                    component: () => import("@/views/group/About/about.vue")
                },
                {
                    path: '/contact',
                    component: () => import("@/views/group/Contact/contact.vue")
                },
                {
                    path: '/contact1',
                    component: () => import("@/views/group/Contact1/contact.vue")
                },
                {
                    path: '/join',
                    component: () => import("@/views/group/Join/join.vue")
                }
            ]
        },
        {
            path: '/coffee',
            component: () => import("@/views/coffee/index.vue"),
            redirect: '/coffee/home',
            children: [
                {
                    path: '/coffee/home',
                    component: () => import("@/views/coffee/Home/home.vue")
                },
                {
                    path: '/coffee/gourmet',
                    component: () => import("@/views/coffee/Gourmet/gourmet.vue")
                },
                {
                    path: '/coffee/history',
                    component: () => import("@/views/coffee/History/history.vue")
                },
                {
                    path: '/coffee/boutique',
                    component: () => import("@/views/coffee/Boutique/boutique.vue")
                },
                {
                    path: '/coffee/disclaimer',
                    component: () => import("@/views/coffee/disclaimer.vue")
                },
                {
                    path: '/coffee/use',
                    component: () => import("@/views/coffee/use.vue")
                },
                {
                    path: '/coffee/desc',
                    component: () => import("@/views/coffee/desc.vue")
                }
            ]
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
    },
})

export default router